//https://react-syntax-highlighter.github.io/react-syntax-highlighter/demo/prism.html
import ReactDom from 'react-dom';
import { useState, useEffect } from 'react';

import { OWNER, PRISM_LANGUAGE_MAP } from '../utils/DataParser';
import { octokit } from '../utils/OctoKit';

import { PrismAsyncLight as SyntaxHighlighter} from "react-syntax-highlighter";
import cpp from 'react-syntax-highlighter/dist/esm/languages/prism/cpp';
import java from 'react-syntax-highlighter/dist/esm/languages/prism/java';
import python from 'react-syntax-highlighter/dist/esm/languages/prism/python';
import sql from 'react-syntax-highlighter/dist/esm/languages/prism/sql';
import tomorrow from 'react-syntax-highlighter/dist/esm/styles/prism/tomorrow';

SyntaxHighlighter.registerLanguage('cpp', cpp);
SyntaxHighlighter.registerLanguage('java', java);
SyntaxHighlighter.registerLanguage('python', python);
SyntaxHighlighter.registerLanguage('sql', sql);

export default function CodeModal({ close, data, show, solutionPath }) {

  const [codeData, setCodeData] = useState(null);

  useEffect(() => {
    const fetchCodeFile = async () => {
      await octokit.request(
        'GET /repos/{owner}/{repo}/contents/{path}',
        {
          owner: OWNER,
          repo: data.repo,
          path: data.path
        }
      ).then(response => {
        const encoded = response.data.content;
        const decoded = atob(encoded);
        setCodeData(decoded);
        console.log('CodeModal UseEffect Called');
      }).catch(error => console.log(error));
    }

    fetchCodeFile();
  }, [data])

  return ReactDom.createPortal(
    show ? (<>
      <div className="code-modal-background" onClick={() => close()}>
        <div className="code-modal-content" onClick={(e) => e.stopPropagation()}>
          <div className="code-modal-hf code-modal-header-border">
            <h2>{data.name}</h2>
            <h3>
              <a href={`${solutionPath}${data.path}`} style={{color: "rgb(114, 225, 255)"}}target="_blank" rel="noopener noreferrer">{`${data.language} Solution`}</a>
            </h3>
          </div>
          <div className='code-modal-body'>
              <SyntaxHighlighter children={codeData} language={PRISM_LANGUAGE_MAP[data.language]} showLineNumbers={true} style={tomorrow}/>
          </div>
          <div className="code-modal-hf code-modal-footer-border">
            <button className='problem-button code-modal-close-btn' onClick={close}>
              <h3>
                Close
              </h3>
            </button>
          </div>
        </div>
      </div>
    </>) : null,
    document.getElementById('code-solution-modal')
  )
}